import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

type ThisApi = ApiDefinition['/dynamic-pdf-templates/{id}']['DELETE'];

type Input = {
  id: string;
};

type Output = ThisApi['response'];

const deleteDynamicPdfTemplateById = async ({ id }: Input): Promise<Output> => {
  try {
    const response = await formsBackendClient.delete(`/dynamic-pdf-templates/${id}`);
    return response.data;
  } catch (error) {
    console.error('Failed to delete dynamic PDF template', error);
    throw error;
  }
};

export default deleteDynamicPdfTemplateById;
